import { render, staticRenderFns } from "./SavedListTable.vue?vue&type=template&id=cea90438&"
import script from "./SavedListTable.vue?vue&type=script&lang=js&"
export * from "./SavedListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports